import { ILocationFilterProvider } from '@/interfaces/filter-providers/ILocationFilterProvider';
import { FilterKey } from '../FilterKey';
import { ClearFilterTag } from './ClearFilterTag';
import { IFilterProviderEnhanced } from '@/interfaces/filter-providers/IFilterProviderEnhanced';

export class CityClearFilterTag extends ClearFilterTag {

	public constructor(
		public readonly values: readonly string[],
		public readonly required: boolean,
		public readonly disabled: boolean,
		public readonly filterProvider: IFilterProviderEnhanced,
		public readonly locationFilterProvider: ILocationFilterProvider
	) {
		super(FilterKey.CITY, values, required, disabled, filterProvider);
	}

	protected override getDisplayNameForSingleValue(): string {
		return 'City';
	}
}
